import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-satisfaction-list-card',
  templateUrl: './satisfaction-list-card.component.html',
  styleUrls: ['./satisfaction-list-card.component.scss']
})
export class SatisfactionListCardComponent implements OnInit {

  @Input() data;
  creationDateOrder;
  centerOrder;
  deviceOrder;
  appOrder;
  pointsOrder;
  customer_notesOrder;

  constructor() { }

  ngOnInit() {
    this.resetSortOrders();
  }


  public resetSortOrders() {
    this.creationDateOrder = 0;
    this.centerOrder = 0;
    this.deviceOrder = 0;
    this.appOrder = 0;
    this.pointsOrder = 0;
    this.customer_notesOrder = 0;
  }

  public sortBy(attribute) {
    switch (attribute) {
      case 'creationDate':
        this.creationDateOrder = (this.creationDateOrder === 0) ? 1 : (this.creationDateOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.creationDate = a.creationDate ? a.creationDate : 0;
            b.creationDate = b.creationDate ? b.creationDate : 0;
            return (a.creationDate < b.creationDate) ? -this.creationDateOrder : (a.creationDate) ? this.creationDateOrder : 0;
          });
        break;
      case 'centerName':
        this.centerOrder = (this.centerOrder === 0) ? 1 : (this.centerOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.centerName = a.centerName ? a.centerName : ' ';
            b.centerName = b.centerName ? b.centerName : ' ';
            return (a.centerName.toUpperCase() < b.centerName.toUpperCase()) ? -this.centerOrder : (a.centerName.toUpperCase() > b.centerName.toUpperCase()) ? this.centerOrder : 0;
          });
        break;
      case 'deviceName':
        this.deviceOrder = (this.deviceOrder === 0) ? 1 : (this.deviceOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.deviceName = a.deviceName ? a.deviceName : ' ';
            b.deviceName = b.deviceName ? b.deviceName : ' ';
            return (a.deviceName.toUpperCase() < b.deviceName.toUpperCase()) ? -this.deviceOrder : (a.deviceName.toUpperCase() > b.deviceName.toUpperCase()) ? this.deviceOrder : 0;
          });
        break;
      case 'appName':
        this.appOrder = (this.appOrder === 0) ? 1 : (this.appOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.appName = a.appName ? a.appName : ' ';
            b.appName = b.appName ? b.appName : ' ';
            return (a.appName.toUpperCase() < b.appName.toUpperCase()) ? -this.appOrder : (a.appName.toUpperCase() > b.appName.toUpperCase()) ? this.appOrder : 0;
          });
        break;
      case 'points':
        this.pointsOrder = (this.pointsOrder === 0) ? 1 : (this.pointsOrder === 1) ? -1 : 1;
        this.data = this.data.sort(
          (a, b) => {
            a.points = a.points ? a.points : a.points;
            b.points = b.points ? b.points : b.points;
            return (a.points < b.points) ? -this.pointsOrder : (a.points > b.points) ? this.pointsOrder : 0;
          });
        break;
    }
  }

}
